import {deserialize} from "cerialize";

export class PlotComparisonTotal {
    @deserialize
    id: number;

    @deserialize
    area: number = 0;

    @deserialize
    income: number = 0;

    @deserialize
    cost: number = 0;

    @deserialize
    result: number = 0;

    @deserialize
    incomeHa: number = 0;

    @deserialize
    costHa: number = 0;

    @deserialize
    resultHa: number = 0;
}

export default class PlotComparison {
    @deserialize
    id: number;

    @deserialize
    plot: number = 0;

    @deserialize
    cycle: number = 0;

    @deserialize
    area: number = 0;

    @deserialize
    productivity: number = 0;

    @deserialize
    income: number = 0;

    @deserialize
    cost: number = 0;

    @deserialize
    datePlantingDue?: string;

    @deserialize
    result: number = 0;
}

